export default "__VITE_ASSET__BbYrUz_c__"